import { FC } from "react";
import { IconProps } from "./types";

export const Spinner: FC<IconProps> = ({
  fill = "#A0B9B9",
  width = 88,
  height = 89,
  className,
  ...props
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 88 89"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    data-automation-id="spinner"
    {...props}
  >
    <g clipPath="url(#clip0_5418_13439)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M24.3832 5.0994L29.2855 14.942L29.2924 14.9386C36.261 11.4696 44.2317 10.5755 51.7959 12.4143C55.0642 13.2088 58.1657 14.4914 61.0054 16.1986C64.74 18.4439 68.0216 21.4236 70.634 24.9934C75.2327 31.2775 77.4614 38.9852 76.9259 46.7538C76.3905 54.5225 73.1254 61.8516 67.7079 67.4453C62.2905 73.039 55.0696 76.537 47.3221 77.3208C39.5746 78.1046 31.7995 76.1238 25.3714 71.7285C21.7198 69.2317 18.6366 66.0471 16.2729 62.3863C14.4757 59.6028 13.0945 56.5439 12.1958 53.3027C10.1152 45.7988 10.7549 37.8008 14.0018 30.723L4.00733 26.1381L4.00324 26.1471C3.73512 26.7319 3.48035 27.3214 3.23896 27.9152C1.77857 31.5076 0.808123 35.2559 0.335556 39.0608C-0.373773 44.772 0.0386507 50.6107 1.5997 56.2407C1.68607 56.5522 1.77579 56.8625 1.86881 57.1714C4.76327 66.7838 10.8622 75.1282 19.165 80.8054C27.7347 86.665 38.1002 89.3058 48.429 88.2608C58.7577 87.2158 68.3843 82.5524 75.6066 75.0951C82.829 67.6377 87.1819 57.8668 87.8958 47.51C88.6097 37.1531 85.6385 26.8774 79.5076 18.4996C73.5676 10.3827 65.0323 4.55405 55.3321 1.96874C55.0203 1.88565 54.7074 1.80591 54.3933 1.72956C48.7161 0.349493 42.8673 0.124151 37.1817 1.01591C33.3939 1.61001 29.6785 2.69993 26.1347 4.27455C25.5509 4.53397 24.9717 4.80656 24.3976 5.09224L24.3832 5.0994Z"
        fill={fill}
      />
    </g>
    <defs>
      <clipPath id="clip0_5418_13439">
        <rect
          width="88"
          height="88"
          fill="white"
          transform="translate(0 0.484375)"
        />
      </clipPath>
    </defs>
  </svg>
);
